import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactApiService {
  private readonly baseUrl = environment.SUPPORT_BASE_URL;
  private readonly endpoint = '/contact';

  constructor(private http: HttpClient) {}

  public postFormData(formData: FormData): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}${this.endpoint}`, formData);
  }
}
